export enum SortDirection {
  ASC = 'Asc',
  DESC = 'Desc',
}
